import { render } from "./TrafficAlertRulesView.vue?vue&type=template&id=38536cac"
import script from "./TrafficAlertRulesView.vue?vue&type=script&lang=js"
export * from "./TrafficAlertRulesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__